import DriveResult from "./driveResult";
import WalkResult from "./walkResult";
import TransitResult from "./transitResult";
import MapResultRoute from "./mapRenderRoute";

const NaviResultComponent = (
  {map, naviSearch, setNaviSearch, naviToggle,naviStart,naviEnd,resultError,setResultError,naviFromToggle,
    naviVia1, naviVia2 ,naviVia3 ,naviVia4 ,naviVia5, isSmp, setIsSmp, setNaviURLParam, isTablet, style}
) => {
  const validateNaviSearch = () => {
    // 出発地と目的地が設定されているか確認
    const start = naviStart;
    const end = naviEnd;
    const hasStart = [start.name, start.lat, start.lon].every(Boolean);
    const hasEnd = [end.name, end.lat, end.lon].every(Boolean);

    return hasStart && hasEnd;
  };

  return (
    <div className="navi-result-component">
      {naviSearch.type === 'drive' && validateNaviSearch() && (
        <div className="desktop-search-panel">
          <DriveResult
            naviSearch={naviSearch}
            setNaviSearch={setNaviSearch}
            map={map}
            naviToggle={naviToggle}
            naviStart={naviStart}
            naviEnd={naviEnd}
            naviVia1={naviVia1}
            naviVia2={naviVia2}
            naviVia3={naviVia3}
            naviVia4={naviVia4}
            naviVia5={naviVia5}
            isSmp={isSmp}
            setIsSmp={setIsSmp}
            naviFromToggle={naviFromToggle}
            setNaviURLParam={setNaviURLParam}
            resultError={resultError}
            setResultError={setResultError}
            isTablet={isTablet}
          />

        </div>
      )}
      {naviSearch.type === 'walk' && validateNaviSearch() && (
        <div className="desktop-search-panel">
          <WalkResult
            naviSearch={naviSearch}
            setNaviSearch={setNaviSearch}
            map={map}
            naviToggle={naviToggle}
            naviStart={naviStart}
            naviEnd={naviEnd}
            resultError={resultError}
            setResultError={setResultError}
            isSmp={isSmp}
            setIsSmp={setIsSmp}
            naviFromToggle={naviFromToggle}
            setNaviURLParam={setNaviURLParam}
            isTablet={isTablet}
          />

        </div>
      )}
      {naviSearch.type === 'transit' && validateNaviSearch() && (
        <div className="desktop-search-panel">
          <TransitResult
            naviSearch={naviSearch}
            setNaviSearch={setNaviSearch}
            map={map}
            naviToggle={naviToggle}
            naviStart={naviStart}
            naviEnd={naviEnd}
            resultError={resultError}
            setResultError={setResultError}
            isSmp={isSmp}
            setIsSmp={setIsSmp}
            naviFromToggle={naviFromToggle}
            setNaviURLParam={setNaviURLParam}
            isTablet={isTablet}
          />

        </div>
      )}
      <MapResultRoute
        naviSearch={naviSearch}
        setNaviSearch={setNaviSearch}
        map={map}
        isSearchValid={validateNaviSearch()}
        isTablet={isTablet}
        style={style}
      />
    </div>
  );
}

export default NaviResultComponent;
